import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import { useState, useCallback, useEffect } from 'react';
import { shape, string, arrayOf, bool, number, func } from 'prop-types';
import Transform from '../Helpers/Transform.js';
import { parseJwt, isChina, debounce, buildTypeAheadQuery } from '../Helpers/Utilities.js';
import { urls } from '../Helpers/Const.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useSuggestions = function useSuggestions(props) {
  var isFocus = props.isFocus,
    value = props.value,
    suggest = props.suggest,
    searchCount = props.searchCount,
    adfsToken = props.adfsToken,
    recent = props.recent,
    aosUrl = props.aosUrl,
    appName = props.appName,
    listData = props.listData,
    type = props.type,
    accountId = props.accountId,
    historyData = props.historyData,
    filters = props.filters,
    setLoading = props.setLoading,
    scope = props.scope,
    locale = props.locale,
    customSearchFunc = props.customSearchFunc,
    customTransformFunc = props.customTransformFunc,
    debounceTime = props.debounceTime,
    C360SearchTestConsumerApp = props.C360SearchTestConsumerApp;
  var c360SearchUrl = urls.c360SearchUrl,
    recentSearchUrl = urls.recentSearchUrl;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    searchResults = _useState2[0],
    setSearchResults = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isHistory = _useState4[0],
    setIsHistory = _useState4[1];
  var userInfo = parseJwt(adfsToken);
  var showRecent = isFocus && suggest && !(value !== null && value !== void 0 && value.length);
  var searchC360 = isFocus && suggest && (isChina() ? (value === null || value === void 0 ? void 0 : value.length) >= 2 : (value === null || value === void 0 ? void 0 : value.length) >= 3);
  var userName = userInfo === null || userInfo === void 0 ? void 0 : userInfo.samaccountname;
  var queryParams = "?userName=".concat(userName, "&applicationName=").concat(appName, "&searchCount=").concat(searchCount, "&type=").concat(type, "&accountId=").concat(accountId);
  var transformResult = function transformResult(resp, term) {
    var _resp$data, _resp$data$data, _resp$data$data$globa;
    var result = (resp === null || resp === void 0 ? void 0 : (_resp$data = resp.data) === null || _resp$data === void 0 ? void 0 : (_resp$data$data = _resp$data.data) === null || _resp$data$data === void 0 ? void 0 : (_resp$data$data$globa = _resp$data$data.globalSearch) === null || _resp$data$data$globa === void 0 ? void 0 : _resp$data$data$globa.slice(0, searchCount)) || [];
    var transformedData = Transform.typeahead(result, term);
    if (!transformedData || !transformedData.length) return [];
    return [_objectSpread({
      type: type
    }, transformedData === null || transformedData === void 0 ? void 0 : transformedData[0])];
  };
  var getSearchHistory = function getSearchHistory() {
    var headers = {
      headers: {
        Authorization: adfsToken,
        'x-account-locale': locale
      }
    };
    var endpoint = aosUrl + recentSearchUrl + queryParams;
    fetch(endpoint, headers).then(function (res) {
      return res.json();
    }).then(function (res) {
      var _res$data;
      return setSearchResults(Transform.recent(res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.searchTerm, recent));
    })["catch"](function (err) {
      return console.error(err);
    });
  };
  var fetchTypeahead = function fetchTypeahead(term, scopeValue) {
    var requestOptions = {
      body: JSON.stringify({
        query: buildTypeAheadQuery(term, 0, searchCount, filters, scopeValue)
      }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: adfsToken,
        'x-account-locale': locale
      },
      method: 'POST',
      credentials: 'omit'
    };
    if (C360SearchTestConsumerApp) {
      requestOptions.headers.C360_SEARCH_TEST_CONSUMER_APP = C360SearchTestConsumerApp;
    }
    var endpoint = aosUrl + c360SearchUrl;
    setLoading(true);
    var fetchFunc = customSearchFunc ? function () {
      return customSearchFunc(term, scopeValue);
    } : function () {
      return fetch(endpoint, requestOptions);
    };
    var transformFunc = customTransformFunc ? function (result) {
      return [{
        type: type,
        data: customTransformFunc(result, term)
      }];
    } : transformResult;
    fetchFunc().then(/*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(response) {
        var result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(response.status === 200)) {
                _context.next = 5;
                break;
              }
              _context.next = 3;
              return response === null || response === void 0 ? void 0 : response.json();
            case 3:
              result = _context.sent;
              setSearchResults(transformFunc(result, term));
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }())["catch"](function () {
      return setSearchResults(transformFunc({}, term));
    })["finally"](function () {
      setLoading(false);
    });
  };
  var dbFetchTypeahead = useCallback(debounce(fetchTypeahead, debounceTime), []);
  useEffect(function () {
    setSearchResults(null);
  }, [isFocus, value, suggest]);
  useEffect(function () {
    if (showRecent && userName && historyData !== null) {
      if (!historyData) getSearchHistory();else setSearchResults(historyData);
      setIsHistory(true);
    }

    // get and display search results
    if (searchC360) {
      if (!listData) dbFetchTypeahead(value.trim(), scope);else setSearchResults(listData);
      setIsHistory(false);
    }
  }, [showRecent, value, listData, historyData]);
  return {
    searchResults: searchResults,
    isHistory: isHistory
  };
};
var DDL = shape({
  label: string.isRequired,
  value: string
});
var searchResultsPropType = arrayOf(shape({
  type: string,
  data: arrayOf(DDL)
}));
useSuggestions.propTypes = {
  isFocus: bool.isRequired,
  value: string.isRequired,
  locale: string,
  suggest: bool.isRequired,
  searchCount: number.isRequired,
  adfsToken: string.isRequired,
  recent: string.isRequired,
  aosUrl: string.isRequired,
  appName: string.isRequired,
  listData: searchResultsPropType,
  type: string.isRequired,
  accountId: string,
  historyData: searchResultsPropType,
  customSearchFunc: func,
  customTransformFunc: func,
  C360SearchTestConsumerApp: string
};

export { useSuggestions as default };
